import axios from "axios";
import { shouldCallCorporateHubEndpoint } from "./../helpers/ShouldCallCorporateHubEndpoint";

export function getMakeAClaimUrl(membershipNumber, action, preAuth) {
  var url = shouldCallCorporateHubEndpoint()
    ? "messagecentre/makeaclaimforbristol"
    : "messagecentre/makeaclaim";

  return axios
    .get(url, {
      params: {
        membershipNumber: membershipNumber,
        action: action,
        preAuth: preAuth
      }
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      throw error && error.response && error.response.data;
    });
}
